import { Link } from "react-router-dom";
import { Briefcase, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/content";

export const CommercialCallout = () => (
  <section className="bg-slate-50 py-20 sm:py-28" data-testid="commercial-callout">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <div className="overflow-hidden rounded-[2rem] shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
          <img src={IMAGES.kitchen} alt="Clean, professional commercial premises in Dublin" className="aspect-[4/3] w-full object-cover" loading="lazy" />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-emerald-700">
          <Briefcase size={13} /> For businesses
        </span>
        <h2 className="mt-4 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          Office and Commercial Cleaning in Dublin
        </h2>
        <p className="mt-4 text-lg text-slate-600">
          We also provide one-off and recurring cleaning services for offices and other business
          premises across Dublin and Kildare. Businesses can request regular weekly cleaning,
          scheduled cleaning plans or a customised cleaning contract based on the size and
          requirements of the premises.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link to="/business-cleaning-contracts-dublin" data-testid="home-business-quote-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-emerald-700 px-7 py-4 text-base font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-emerald-800">
            Request a Business Quote <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/commercial-cleaning-dublin" data-testid="home-commercial-link"
            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-slate-200 px-7 py-4 text-base font-bold text-slate-800 transition-all hover:border-emerald-600 hover:text-emerald-700">
            View Commercial Cleaning Services
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
